var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6207 9.20139C16.9853 9.67831 16.9853 10.3222 16.6207 10.7983C15.4722 12.2975 12.7169 15.3845 9.49993 15.3845C6.28301 15.3845 3.52763 12.2975 2.37916 10.7983C2.20177 10.57 2.10547 10.289 2.10547 9.99985C2.10547 9.71068 2.20177 9.42975 2.37916 9.20139C3.52763 7.70216 6.28301 4.61523 9.49993 4.61523C12.7169 4.61523 15.4722 7.70216 16.6207 9.20139V9.20139Z",
    stroke: "black",
    strokeWidth: 1.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50105 12.3075C10.7756 12.3075 11.8087 11.2743 11.8087 9.99983C11.8087 8.72533 10.7756 7.69214 9.50105 7.69214C8.22655 7.69214 7.19336 8.72533 7.19336 9.99983C7.19336 11.2743 8.22655 12.3075 9.50105 12.3075Z",
    stroke: "black",
    strokeWidth: 1.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeBlack);
export default __webpack_public_path__ + "static/media/eye-black.db4987eeb9b308867b65087390594440.svg";
export { ForwardRef as ReactComponent };